import { render } from "./Upload.vue?vue&type=template&id=2cb00305&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"

import "./Upload.vue?vue&type=style&index=0&id=2cb00305&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cb00305"

export default script